import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';

const Industries = () => {
  const industries = [
  {
    icon: 'fa-university',
    name: 'Financial Services',
    description: 'Risk management, credit scoring and regulatory compliance powered by trustworthy AI.',
    link: "/financial-services"
  },
  {
    icon: 'fa-graduation-cap',
    name: 'Education',
    description: 'Automated assessment, student analytics and adaptive learning at institutional scale.',
    link: "/education"
  },
  {
    icon: 'fa-heart',
    name: 'Healthcare',
    description: 'Clinical analytics, patient-pathway optimisation and operational efficiency for providers and payers.',
    link: "/healthcare"
  },
  {
    icon: 'fa-bolt',
    name: 'Energy & Utilities',
    description: 'Predictive maintenance, demand forecasting and grid optimisation for a net-zero future.',
    link: "/energy-utilities"
  }
];


  return (
    <section id="industries" className="industries-section">
      <div className="container">
        <div className="section-header">
          <h2>Industries We Serve</h2>
          <p>
            Deep domain expertise across regulated and data-intensive sectors.
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => {
            const CardContent = (
              <>
                <div className="industry-icon">
                  <i className={`fas ${industry.icon}`}></i>
                </div>
                <h3>{industry.name}</h3>
                <p>{industry.description}</p>
              </>
            );

            return industry.link ? (
              <Link key={index} to={industry.link} className="industry-card">
                {CardContent}
              </Link>
            ) : (
              <div key={index} className="industry-card">
                {CardContent}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
